import { render, staticRenderFns } from "./ProductRegion.vue?vue&type=template&id=4952a072&scoped=true&"
import script from "./ProductRegion.vue?vue&type=script&lang=js&"
export * from "./ProductRegion.vue?vue&type=script&lang=js&"
import style0 from "./ProductRegion.vue?vue&type=style&index=0&id=4952a072&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4952a072",
  null
  
)

export default component.exports